import(/* webpackMode: "eager" */ "/codebuild/output/src2174506986/src/pitch-perfect-frontend/app/(root)/page.tsx");
